const isEnabled = (value: unknown): boolean =>
  value === true || value === "true" || value === 1 || value === "1";

export const hasPendingInviteWheelEntry = (): boolean => {
  const params = new URLSearchParams(window.location.search);
  if (params.has("shareSpin")) return isEnabled(params.get("shareSpin"));
  try {
    return isEnabled(
      JSON.parse(sessionStorage.getItem("search") || "{}").shareSpin
    );
  } catch {
    return false;
  }
};

/** 只消费转盘入口；邀请码及其他归因、登录数据继续沿用原有合同。 */
export const completeInviteWheelEntry = (): void => {
  const url = new URL(window.location.href);
  url.searchParams.delete("shareSpin");
  url.searchParams.delete("wheelShown");
  window.history.replaceState(window.history.state, "", url.toString());
  try {
    const search = JSON.parse(sessionStorage.getItem("search") || "{}");
    delete search.shareSpin;
    delete search.wheelShown;
    sessionStorage.setItem("search", JSON.stringify(search));
  } catch {
    // 浏览器可能禁用存储；当前 URL 已消费，不影响队列继续执行。
  }
};
